import { Injectable, NgZone, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import type { TranslationKey } from 'src/app/core/models/translation.model';

const CLASS_MAP = {
  info: 'info-snackbar',
  success: 'success-snackbar',
  warn: 'warn-snackbar',
  error: 'error-snackbar'
} as const;

type SnackBarType = keyof typeof CLASS_MAP;

@Injectable({
  providedIn: 'root'
})
export class SnackbarNotificationService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly zone = inject(NgZone);
  private readonly translateService = inject(TranslateService);

  info(key: TranslationKey) {
    this.show(this.translateService.instant(key), 'info');
  }

  success(key: TranslationKey) {
    this.show(this.translateService.instant(key), 'success');
  }

  warn(key: TranslationKey) {
    this.show(this.translateService.instant(key), 'warn');
  }

  error(key: TranslationKey) {
    this.show(this.translateService.instant(key), 'error');
  }

  text(message: string, type: SnackBarType) {
    this.show(message, type);
  }

  private show(message: string, type: SnackBarType) {
    // Outside the Angular zone nothing runs change detection to position the overlay — e.g. Highcharts callbacks.
    this.zone.run(() =>
      this.snackBar.open(message, '✕', {
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        duration: 5000,
        panelClass: CLASS_MAP[type]
      })
    );
  }
}
